import React, { useEffect, useState } from 'react';
import { Card, Breadcrumb } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import { CourseManager } from '@components/admin/CourseManager';
import { repositoryFactory } from '@data';
import { useAuth } from '@context';
import { canManageCourse } from '@utils/permissions';

export function CourseDetailPage() {
  const { courseId } = useParams();
  const { user } = useAuth();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadCourse = async () => {
    setLoading(true);
    const repo = repositoryFactory.getCourseRepository();
    const courseData = await repo.getCourseById(courseId);
    setCourse(courseData);
    setLoading(false);
  };

  useEffect(() => {
    loadCourse();
  }, [courseId]);

  if (loading) {
    return <div className="text-center p-5">Loading course...</div>;
  }

  if (!course) {
    return <div className="text-center p-5">Course not found.</div>;
  }

  if (!canManageCourse(user, courseId)) {
    return <div className="text-center p-5">Access denied: You are not assigned to manage this course.</div>;
  }

  return (
    <div>
      <Breadcrumb className="mb-3">
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/courses' }}>Courses</Breadcrumb.Item>
        <Breadcrumb.Item active>{course.title}</Breadcrumb.Item>
      </Breadcrumb>

      <div className="mb-4">
        <h3 className="mb-1">🏛️ {course.title}</h3>
        {course.description && <p className="text-muted mb-0">{course.description}</p>}
      </div>

      <Card className="shadow-sm">
        <Card.Body>
          <CourseManager course={course} onRefresh={loadCourse} />
        </Card.Body>
      </Card>
    </div>
  );
}
